module.exports = {
    drawChart: function(resultList, graphIndex) {
        var chart = AmCharts.makeChart("mediaLevelChartdiv", {
          "type": "serial",
          "thousandsSeparator": ",",
          "precision": 2,
        	"categoryField": "grps",
        	"startDuration": 1,
          "sequencedAnimation": false,
          "startEffect": "easeOutSine",
        	"categoryAxis": {
        		"gridPosition": "start"
        	},
        	"trendLines": [],
        	"graphs": [
        		{
              "lineColor": "#9400d3",
        			"balloonText": "GRPs : [[category]]<br>Reach 1+ : [[value]]",
              "bulletBorderAlpha": 1,
        			"bulletBorderColor": "#9400d3",
        			"bulletColor": "#FFFFFF",
        			"bulletOffset": -2,
              "bulletSizeField": "bulletSize",
              "bulletField": "bullet",
        			"id": "AmGraph-1",
        			"title": "매체 " + graphIndex,
        			"valueField": "reach1"
        		}
        	],
        	"guides": [],
        	"valueAxes": [
        		{
        			"id": "ValueAxis-1",
              "maximum": 100,
        			"title": "Reach 1+"
        		}
        	],
        	"allLabels": [],
        	"balloon": {},
        	"legend": {
        		"enabled": true,
        		"useGraphSettings": true
        	},
        	"titles": [
        		// {
        		// 	"id": "Title-1",
        		// 	"size": 15,
        		// 	"text": "Chart Title"
        		// }
        	],
            "dataProvider": resultList
        });
    }
}



// WEBPACK FOOTER //
// ./src/views/reach/da/result/mediaLevelChart.js